// react
import PropTypes from 'prop-types';

// redux
import { useSelector } from 'react-redux';

// project imports
import Unauthorised from '../../views/unauthorised/Unauthorised';
import InvoicingAndPaymentsDisabled from '../../views/invoicing-and-payments-disabled/InvoicingAndPaymentsDisabled';
import { useGeneralInvoicingAndPaymentsEnabled } from 'hooks/usePayments';

const PrivateRoute = ({ children, role, restrictedTo, requiresInvoicingAndPayments }) => {
  const userData = useSelector((state) => state.user.data);
  const generalInvoicingAndPaymentsEnabled = useGeneralInvoicingAndPaymentsEnabled();

  const enabledPermissions = userData.AccessRoles.reduce((prev, curr) => {
    const permissions = JSON.parse(curr.permissions);
    return [...new Set([...prev].concat(permissions))];
  }, []);

  const userHasRole = enabledPermissions.includes(role);

  const userTypeAllowed = restrictedTo ? restrictedTo.includes(userData.type) : true;

  // Invoicing and Payments pages are hidden from the sidebar when the feature is off; block direct
  // URL access too so the routes are not reachable by typing or bookmarking the link.
  if (requiresInvoicingAndPayments && !generalInvoicingAndPaymentsEnabled) {
    return <InvoicingAndPaymentsDisabled />;
  }

  if (!userHasRole || !userTypeAllowed) {
    return <Unauthorised />;
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node,
  role: PropTypes.string,
  restrictedTo: PropTypes.array,
  requiresInvoicingAndPayments: PropTypes.bool
};

export default PrivateRoute;
